import type { SVGProps } from 'react'

interface CaatingaBiomeIconProps extends SVGProps<SVGSVGElement> {}

export function CaatingaBiomeIcon(props: CaatingaBiomeIconProps) {
  return (
    <svg
      width={22}
      height={34}
      viewBox="0 0 22 34"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.143 34c-.4 0-.786-.166-1.077-.464a1.761 1.761 0 01-.49-1.136 1.792 1.792 0 01.364-1.19 1.542 1.542 0 011.019-.598l.184-.011h3.143V20.401c-1.613 0-3.164-.67-4.332-1.873C.785 17.327.088 15.685.008 13.943L0 13.603v-1.7c0-.433.154-.85.429-1.165.275-.315.65-.504 1.05-.53.4-.025.794.116 1.101.394.307.278.505.672.552 1.102l.01.2v1.699c0 .858.3 1.684.84 2.313a3.057 3.057 0 002.068 1.078l.236.009V5.104c-.001-1.327.476-2.603 1.33-3.555C8.471.596 9.635.04 10.862.002c1.226-.039 2.419.441 3.323 1.338.905.897 1.45 2.14 1.521 3.465l.008.3v16.997c.793 0 1.557-.324 2.138-.907a3.515 3.515 0 00.997-2.238l.008-.255v-8.499c0-.433.154-.85.429-1.165.275-.315.65-.504 1.05-.53.4-.025.794.116 1.101.394.307.278.505.672.552 1.103l.011.198v8.5c0 1.744-.62 3.421-1.731 4.685-1.112 1.264-2.63 2.017-4.24 2.105l-.315.008v5.1h3.143c.4 0 .786.166 1.077.463.291.298.467.704.49 1.137.024.432-.107.858-.364 1.19a1.542 1.542 0 01-1.019.597l-.184.012H3.143z"
        fill="currentColor"
      />
    </svg>
  )
}
